import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CustomTextField from "../../inputComponent/CustomTextField/CustomTextField";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import ErrorMsg from "../ErrorMsg/ErrorMsg";
// import { useForm } from "react-hook-form";
import { useFormContext, useController, Controller } from "react-hook-form";
import ClearIcon from "@mui/icons-material/Clear";

import {
    Box,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    responsible: {
        width: "16px",
        height: "16px",
    },
    color: {
        color: "#333",
    },
    border: {
        backgroundColor: "#e8e3cd",
        width: "805px",
        margin: "0 0 5px -9px",
        padding: "9px 0 9px 7px",
    },
    bottom: {
        marginBottom: "8px",
    },
    right: {
        marginRight: "0",
    },
    table: {
        minWidth: 650,
    },

    // css style for table
    locationColumn: {
        height: "50px",
        width: "200px",
        textAlign: "center",
    },

    locationBody: {
        width: "200px",
        textAlign: "center",
    },

    figureA: {
        width: "80%",
        marginLeft: "10%",
        marginRight: "10%",
    },
}));

export default function MultiColumnTable({
    headers,
    numOfColumnPerPage,
    label,
    formId,
    errors,
    records,
    control,
    handleAppend,
    handleRemove,
    // register,
    ...rest
}) {
    const [page, setPage] = useState(0);
    const { t, i18n } = useTranslation();
    // const lastPage = deduceLastPage();
    const numOfColumn = headers.length;
    const styles = useStyles();

    // const { getValues, register } = useForm();
    // const { register } = useFormContext();

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const deduceHeaderSequence = () => {};

    const deduceLastPage = () => {
        return (numOfColumn - 1) / numOfColumnPerPage;
    };

    const handleAppendRecord = () => {};

    const ConditionalRender = (props) => {
        const condition = props.condition;
        const Render = props.render;

        if (condition) {
            return <Render />;
        }
        return <></>;
    };

    const tableCellHeader = (headers, formId, key) => {
        return (
            <TableRow>
                <TableCell>
                    <Typography>
                        {t(`${formId}.demMultiTable.${headers[0].name}`)}
                    </Typography>
                </TableCell>
                {headers
                    .slice(
                        1 + key * numOfColumnPerPage,
                        numOfColumnPerPage + key * numOfColumnPerPage + 1
                    )
                    .map((header) => (
                        <TableCell key={header}>
                            <Typography>
                                {t(`${formId}.demMultiTable.${header.name}`)}
                            </Typography>
                        </TableCell>
                    ))}
                {/* {ventilationFieldArray.fields.length > 1 && (
                    <TableCell></TableCell>
                )} */}
            </TableRow>
        );
    };

    const tableCellBody = (headers, formId, key, records, errors) => {
        console.log("tableCellBody");
        return (
            <>
                {records.map((record, index) => (
                    <TableRow key={record}>
                        <TableCell className={styles.locationBody}>
                            <Controller
                                name={`multiTable.[${index}].field1`}
                                control={control}
                                render={({ field }) => (
                                    <CustomTextField
                                        inputProps={{
                                            ...field,
                                            style: {
                                                textAlign: "center",
                                            },
                                            type: () =>
                                                headers[0].type === "number"
                                                    ? "number"
                                                    : "string",
                                        }}
                                        error={
                                            errors?.multiTable?.[index]?.field1
                                        }
                                    />
                                )}
                            />
                        </TableCell>
                        {headers
                            .slice(
                                1 + key * numOfColumnPerPage,
                                numOfColumnPerPage +
                                    key * numOfColumnPerPage +
                                    1
                            )
                            .map((key) => {
                                let fieldType;
                                key.type === "number"
                                    ? (fieldType = "number")
                                    : (fieldType = "string");

                                return (
                                    <TableCell align="center" key={key}>
                                        <Controller
                                            name={`multiTable.[${index}].${key.name}`}
                                            control={control}
                                            render={({ field }) => (
                                                <CustomTextField
                                                    inputProps={{
                                                        ...field,
                                                        style: {
                                                            textAlign: "center",
                                                        },
                                                        type: fieldType,
                                                    }}
                                                    error={
                                                        errors?.multiTable?.[
                                                            index
                                                        ]?.[key.name]
                                                    }
                                                />
                                            )}
                                        />
                                    </TableCell>
                                );
                            })}
                        {records.length > 1 && (
                            <TableCell className={styles.cancelButton}>
                                <Button
                                    onClick={() => {
                                        handleRemove(index);
                                    }}
                                >
                                    <ClearIcon />
                                </Button>
                            </TableCell>
                        )}
                    </TableRow>
                ))}
            </>
        );
    };

    const RenderHeaders = (props) => {
        const headers = props.headers;
        const formId = props.formId;
        let items = [];

        for (let key = 0; key < numOfColumnPerPage; key++) {
            items.push(
                <ConditionalRender
                    key={key}
                    condition={page === key}
                    render={() => tableCellHeader(headers, formId, key)}
                />
            );
        }

        return items;
    };

    const RenderBodies = (props) => {
        const headers = props.headers;
        const formId = props.formId;
        let items = [];
        console.log("RenderBodies", numOfColumnPerPage);
        for (let key = 0; key < numOfColumnPerPage; key++) {
            items.push(
                <ConditionalRender
                    key={key}
                    condition={page === key}
                    render={() =>
                        tableCellBody(headers, formId, key, records, errors)
                    }
                />
            );
        }
        console.log("renderBodies", items);

        return items;
    };

    return (
        <>
            <TableContainer>
                <Table className={styles.table} aria-label={label}>
                    <TableHead>
                        <RenderHeaders headers={headers} formId={formId} />
                    </TableHead>

                    <TableBody>
                        <RenderBodies headers={headers} formId={formId} />
                    </TableBody>
                </Table>
            </TableContainer>

            <Box p={5}>
                <Button
                    variant="contained"
                    color="primary"
                    onClick={handleAppend}
                >
                    <Typography>{t("common.button.append")}</Typography>
                </Button>
                {/* &nbsp;&nbsp;
                <ErrorMsg message={errors?.ventSumTest?.message} />
                <ErrorMsg message={errors?.velocityTest?.message} />
                <ErrorMsg message={errors?.ventAirTest?.message} /> */}
            </Box>

            <TablePagination
                component="div"
                page={page}
                rowsPerPage={1}
                count={2}
                rowsPerPageOptions={[1]}
                labelDisplayedRows={({ from, to, count, page }) => {
                    if (i18n.language === "en") {
                        return `column page ${page + 1} of ${count}`;
                    } else {
                        return `頁${page + 1}/ 頁${count}`;
                    }
                }}
                onPageChange={handleChangePage}
            />
        </>
    );
}
